import Home from "./pages/Home";
import lazyWithSkeleton from "./utils/lazyWithSkeleton";
import AboutPageSkeleton from "./components/Skeleton/AboutPageSkeleton";
import ContactPageSkeleton from "./components/Skeleton/ContactPageSkeleton";
import LegalPageSkeleton from "./components/Skeleton/LegalPageSkeleton";
import ProjectPageSkeleton from "./components/Skeleton/ProjectPageSkeleton";
import ProjectsPageSkeleton from "./components/Skeleton/ProjectsPageSkeleton";

const About = lazyWithSkeleton(  () => import("./pages/About"),
  AboutPageSkeleton
);
const Contact = lazyWithSkeleton(
  () => import("./pages/Contact"),
  ContactPageSkeleton
);
const TermsOfService = lazyWithSkeleton(
  () => import("./pages/Footer/TermsOfService"),
  LegalPageSkeleton
);
const PrivacyPolicy = lazyWithSkeleton(
  () => import("./pages/Footer/PrivacyPolicy"),
  LegalPageSkeleton
);
const Projects = lazyWithSkeleton(
  () => import("./pages/Projects"),
  ProjectsPageSkeleton
);
const PortfolioPdf = lazyWithSkeleton(
  () => import("./pages/PortfolioPdf"),
  ProjectsPageSkeleton
);

const AestheticArtGallery = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/aesthetic-art-gallery"),
  ProjectPageSkeleton
);
const CustomPCBuilder = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/custom-pc-builder"),
  ProjectPageSkeleton
);
const FunziesCollection = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/funzies-collection"),
  ProjectPageSkeleton
);
const ICook = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/icook"),
  ProjectPageSkeleton
);
const LifeCanvas = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/lifecanvas"),
  ProjectPageSkeleton
);
const SoundArt = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/soundart"),
  ProjectPageSkeleton
);
const Eversio = lazyWithSkeleton(
  () => import(/* webpackPrefetch: true */ "./pages/Projects/project-eversio"),
  ProjectPageSkeleton
);

const appRoutes = [
  { path: "/", Component: Home },
  { path: "/projects", Component: Projects },
  { path: "/portfolio-pdf", Component: PortfolioPdf },
  { path: "/about", Component: About },
  { path: "/contact", Component: Contact },
  { path: "/terms", Component: TermsOfService },
  { path: "/privacy", Component: PrivacyPolicy },
  { path: "/projects/aesthetic-art-gallery", Component: AestheticArtGallery },
  { path: "/projects/custom-pc-builder", Component: CustomPCBuilder },
  { path: "/projects/funzies-collection", Component: FunziesCollection },
  { path: "/projects/icook", Component: ICook },
  { path: "/projects/lifecanvas", Component: LifeCanvas },
  { path: "/projects/soundart", Component: SoundArt },
  { path: "/projects/eversio", Component: Eversio },
];

export default appRoutes;
